export default {
  setLoading(state, value) {
    state.loading = value;
  },
  setCheckinInfo(state, value) {
    state.checkinInfo = value;
  },
  setPublicPackages(state, value) {
    state.publicPackages = value || [];
  },
};
